/*
  variant-image-filter.js
  Show only the selected colour/design's images in the product gallery, by ALT TEXT.

  Fixes over the previous version:
  - Runs ONLY when the variant changes (or on load) — it no longer reacts to your own
    swipes / thumbnail clicks, so navigating within a colour's images works normally.
  - After hiding non-matching slides it calls the Dawn slider's resetPages(), so the
    "1 / N" counter, the swipe bounds and the thumbnail selection all respect the
    visible slides instead of the full set.

  SAFE BY DEFAULT: only filters a product when the alt-tagging is actually set up
  (at least two of the option's values are found in the image alts). Otherwise it
  leaves the gallery completely untouched. Never leaves an empty gallery.

  Setup: Assets → upload, then in sections/main-product.liquid:
    <script src="{{ 'variant-image-filter.js' | asset_url }}" defer="defer"></script>
*/
(function () {
  if (window.__variantImageFilter) return;
  window.__variantImageFilter = true;

  var GROUPING_RE = /colou?r|design|pattern/i;

  function groupingFieldset() {
    var groups = document.querySelectorAll('.product-form__input');
    for (var i = 0; i < groups.length; i++) {
      var label = groups[i].querySelector('.form__label, legend');
      if (label && GROUPING_RE.test(label.textContent)) return groups[i];
    }
    return null;
  }

  function optionValues(fs) {
    var vals = [];
    fs.querySelectorAll('input[type="radio"]').forEach(function (i) {
      if (i.value) vals.push(i.value.trim());
    });
    if (!vals.length) {
      var sel = fs.querySelector('select');
      if (sel) Array.prototype.forEach.call(sel.options, function (o) {
        if (o.value) vals.push(o.value.trim());
      });
    }
    return vals;
  }

  function selectedValue(fs) {
    var checked = fs.querySelector('input[type="radio"]:checked');
    if (checked) return checked.value.trim();
    var sel = fs.querySelector('select');
    return sel ? sel.value.trim() : '';
  }

  // Re-sync Dawn's gallery sliders after we show/hide slides, and jump to the first
  // visible one. resetPages() re-reads the slides (skipping display:none) and updates
  // the counter + swipe bounds.
  function refreshSliders() {
    document.querySelectorAll('media-gallery slider-component').forEach(function (sc) {
      try {
        if (typeof sc.resetPages === 'function') sc.resetPages();
        if (sc.slider && typeof sc.slider.scrollTo === 'function') {
          sc.slider.scrollTo({ left: 0 });
        }
      } catch (e) {}
    });
  }

  function applyFilter() {
    var items = document.querySelectorAll('.product__media-list > li');
    if (!items.length) return;

    var fs = groupingFieldset();
    if (!fs) return;                      // no colour/design option → never touch the gallery
    var selected = selectedValue(fs);
    if (!selected) return;

    // Collect all main-image alts once.
    var alts = [];
    items.forEach(function (li) {
      var img = li.querySelector('img');
      alts.push(img ? (img.getAttribute('alt') || '').toLowerCase() : '');
    });

    // Safety gate: only filter if the tagging is genuinely set up (>= 2 values present).
    var values = optionValues(fs);
    var represented = 0;
    for (var i = 0; i < values.length; i++) {
      var t = values[i].toLowerCase();
      if (t && alts.some(function (a) { return a.indexOf(t) !== -1; })) represented++;
      if (represented >= 2) break;
    }
    if (represented < 2) return;          // not tagged for this product → leave gallery alone

    var token = selected.toLowerCase();
    var anyVisible = false;

    items.forEach(function (li, i) {
      var match = alts[i].indexOf(token) !== -1;
      li.style.display = match ? '' : 'none';
      if (match) anyVisible = true;
    });

    var thumbs = document.querySelectorAll('.thumbnail-list__item');

    // Never leave an empty gallery — if nothing matched, restore everything.
    if (!anyVisible) {
      items.forEach(function (li) { li.style.display = ''; });
      thumbs.forEach(function (li) { li.style.display = ''; });
      refreshSliders();
      return;
    }

    thumbs.forEach(function (li) {
      var img = li.querySelector('img');
      var a = img ? (img.getAttribute('alt') || '').toLowerCase() : '';
      li.style.display = a.indexOf(token) !== -1 ? '' : 'none';
    });

    refreshSliders();
  }

  // Dawn re-renders the gallery asynchronously after a variant change, so re-apply a few
  // times to catch the final DOM — then stop. No persistent observer, so it never fights
  // your own navigation.
  function applyBurst() {
    applyFilter();
    setTimeout(applyFilter, 250);
    setTimeout(applyFilter, 600);
    setTimeout(applyFilter, 1100);
  }

  // Variant changed (native radios / selects).
  document.addEventListener('change', function (e) {
    if (e.target.closest && e.target.closest('variant-selects')) applyBurst();
  });

  // Our custom colour swatches (label clicks that may not fire a native change).
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('variant-selects .product-form__input--swatch')) {
      applyBurst();
    }
  });

  // Initial load.
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    applyBurst();
  } else {
    window.addEventListener('DOMContentLoaded', applyBurst);
  }
  window.addEventListener('load', applyFilter);
  document.addEventListener('shopify:section:load', applyBurst);
})();